import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class ITSystemAccessInformation extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_it_and_system_access_information');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-5"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'device_info_file')}><i class="fas fa-file-download"></i> System/Device Allocated (Laptop, etc.)</a></div>);
    downloads_div.push(<div className="col-md-5"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'other_device_info_file')}><i class="fas fa-file-download"></i> Other IT product details</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_it_and_system_access_information';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#old_device_info_file').val(data['device_info_file_new_name']);
    $('#email_id').val(data['email_id']);
    $('#old_other_device_info_file').val(data['other_device_info_file_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var email_id          = window.isNullAndUndef($('#email_id').val());
    var device_info_file_temp    = window.isNullAndUndef($('#device_info_file').val());
    var other_device_info_file_temp  = window.isNullAndUndef($('#other_device_info_file').val());
    var org_device_info_file     = $("#device_info_file").prop("files")[0];
    var device_info_file_name    = $('#device_info_file').val().split('\\').pop();
    var org_other_device_info_file   = $("#other_device_info_file").prop("files")[0];
    var other_device_info_file_name  = $('#other_device_info_file').val().split('\\').pop();


    var device_info_file_ext    = '';
    var other_device_info_file_ext  = '';

    if(device_info_file_temp && other_device_info_file_temp){
      device_info_file_ext      = device_info_file_temp.split('.').pop();
      other_device_info_file_ext    = other_device_info_file_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(device_info_file_temp && email_id && other_device_info_file_temp && file_main_ext.indexOf(device_info_file_ext) >= 0 && file_main_ext.indexOf(other_device_info_file_ext) >= 0){
      var old_device_info_file     = $('#old_device_info_file').val();
      var old_other_device_info_file   = $('#old_other_device_info_file').val();
      var all_data                    = {};
      all_data['device_info_file']         = window.return_false_null(device_info_file_name);
      all_data['email_id']          = window.return_false_null(email_id);
      all_data['other_device_info_file']       = window.return_false_null(other_device_info_file_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('device_info_file',org_device_info_file);
      body.append('other_device_info_file',org_other_device_info_file);
      body.append('old_device_info_file',old_device_info_file);
      body.append('old_other_device_info_file',old_other_device_info_file);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_it_and_system_access_information');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('device_info_file','email_id','other_device_info_file');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="email_id" placeholder="Official Email ID"/>
                                        <label for="name">Official Email ID</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_device_info_file" placeholder="Aadhaar Card"/>
                                        <input type="file" className="form-control" id="device_info_file" placeholder="System/Device Allocated (Laptop, etc.)"/>
                                        <label for="name">System/Device Allocated (Laptop, etc.)</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-floating">
                                      <input type="hidden" className="form-control" id="old_other_device_info_file" placeholder="Aadhaar Card"/>
                                      <input type="file" className="form-control" id="other_device_info_file" placeholder="Other IT product details"/>
                                      <label for="name">Other IT product details</label>
                                  </div>
                                </div>




                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default ITSystemAccessInformation;
